export default "__VITE_ASSET__dc6d3413__"